<template>
  <div class="title">
    <div class="message" v-html="$t('message.forbidden_1')" />
    <div class="message" v-html="$t('message.forbidden_2')" />
  </div>
</template>

<script>
export default {
  name: 'Forbidden'
}
</script>

<style scoped>
.message {
  text-align: center;
  margin-bottom: 16px;
}
</style>
